import { PageHero } from "@/components/site/PageHero";
import { CTABand } from "@/components/site/CTABand";
import { Story, Belief, Tomorrow, VisionMission, Values, Founder } from "@/components/about/AboutSections";
import { STORY } from "@/data/about";

export default function About() {
  return (
    <main data-testid="about-page">
      <PageHero eyebrow="About KRIMZON" lines={["The human experience", "of work."]} intro={STORY.intro} image="/img/about_leadership.jpg" testId="about-hero" />
      <Story />
      <Belief />
      <Tomorrow />
      <VisionMission />
      <Values />
      <Founder />
      <CTABand />
    </main>
  );
}
